/**
 * @generated SignedSource<<ad2ffa884940ac4f53ad1f19a208b7da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Footer_SiteInfo$data = {
  readonly znglyInfo: {
    readonly address1: string | null | undefined;
    readonly address2: string | null | undefined;
    readonly address3: string | null | undefined;
    readonly email: string | null | undefined;
    readonly links: ReadonlyArray<{
      readonly linkName: string | null | undefined;
      readonly linkUrl: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly linksTitle: string | null | undefined;
    readonly phone1: string | null | undefined;
    readonly phone2: string | null | undefined;
    readonly privacyUserConsentLevel: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "Footer_SiteInfo";
};
export type Footer_SiteInfo$key = {
  readonly " $data"?: Footer_SiteInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"Footer_SiteInfo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Footer_SiteInfo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ZnglyInfo_Znglyinfo",
      "kind": "LinkedField",
      "name": "znglyInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "privacyUserConsentLevel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "address1",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "address2",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "address3",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "linksTitle",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ZnglyInfo_Znglyinfo_links",
          "kind": "LinkedField",
          "name": "links",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "linkName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "linkUrl",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phone1",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phone2",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ZnglyInfo",
  "abstractKey": null
};

(node as any).hash = "5d9cd5d4f388be0d2d54e3df8948d91d";

export default node;
